import type { fabric } from 'fabric';
import { applyImageFilters, type ImageFilterValues } from '@/lib/imageFilters';

export type BeautyPresetId = 'natural' | 'soft' | 'studio';

export const BEAUTY_PRESETS: Record<
  BeautyPresetId,
  { label: string; values: Partial<ImageFilterValues> }
> = {
  natural: {
    label: 'Natural',
    values: { brightness: 0.04, contrast: 0.05, saturation: 0.04, blur: 0 },
  },
  soft: {
    label: 'Soft',
    values: { brightness: 0.06, contrast: -0.02, saturation: -0.02, blur: 0.08 },
  },
  studio: {
    label: 'Studio',
    values: { brightness: 0.08, contrast: 0.12, saturation: 0.06, blur: 0 },
  },
};

export function applyBeautyPreset(
  canvas: fabric.Canvas,
  img: fabric.Image,
  preset: BeautyPresetId
): ImageFilterValues {
  return applyImageFilters(canvas, img, BEAUTY_PRESETS[preset].values);
}
